<div class="visitor-info container-fluid" [ngClass]="{ 'chat-panel': isChat(), 'email-panel': isEmail() }">
  <div class="bc-panel-header">
    <svg-icon icon="info-outline" class="bc-panel-header-icon"></svg-icon>
    <span class="bc-panel-header-text">{{ 'bcVisitorInfo.visitorInfo' | translate }}</span>
  </div>

  <div *ngIf="visitor" class="bc-panel-body">
    <!-- CHAT and EMAIL -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.name?.visible">
      <div class="info info-name"
           [ngClass]="{ 'grey': !visitor.fields.name.value }"
           title="{{ 'bcVisitorInfo.name' | translate  }} {{ visitor.fields.name.value }}"
           [attr.data-automation-id]="'bc-visitor-info-name'">
        <svg-icon icon="person-filled"></svg-icon>
        <span class="value visitor-info-name" *ngIf="visitor.fields.name.value">{{ visitor.fields.name.value }}</span>
        <span class="value not-available" *ngIf="!visitor.fields.name.value">{{ 'bcVisitorInfo.notAvailable' | translate }}</span>
      </div>
    </div>

    <!-- CHAT and EMAIL -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.email?.visible">
      <div class="info info-email" [ngClass]="{ 'grey': !visitor.fields.email.value }" title="{{ 'bcVisitorInfo.email' | translate  }} {{ visitor.fields.email.value }}">
        <svg-icon icon="mail"></svg-icon>
        <a (click)="editEmail()" *ngIf="canEdit" class="edit-icon"><i class="glyphicon glyphicon-pencil"></i></a>
        <form ngNativeValidate *ngIf="editingEmail" (ngSubmit)="editEmail()">
          <input class="bc-input"
                 id="email-input-field"
                 [(ngModel)]="visitor.fields.email.value"
                 [ngModelOptions]="{standalone: true}"
                 type="email"
                 [ngClass]="{ 'invalid': !visitor.fields.email.value }"
                 #emailInput />
        </form>
        <span class="value not-available" *ngIf="!visitor.fields.email.value && !editingEmail">{{ 'bcVisitorInfo.notAvailable' | translate }}</span>
        <span class="value visitor-info-email"
              *ngIf="visitor.fields.email.value && !editingEmail"
              [attr.data-automation-id]="'bc-visitor-info-email'">
          <a href="mailto:{{ visitor.fields.email.value }}">{{ visitor.fields.email.value }}</a>
        </span>
      </div>
    </div>

    <!-- CHAT and EMAIL -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.folderName?.visible">
      <div class="info info-folder" [ngClass]="{ 'grey': !visitor.fields.folderName.value }" title="{{ 'bcVisitorInfo.folderName' | translate }} {{ visitor.fields.folderName.value }}">
        <svg-icon icon="folder"></svg-icon>
        <span class="value visitor-info-folder"
              *ngIf='visitor.fields.folderName.value'
              [attr.data-automation-id]="'bc-visitor-info-folder'">
          {{ visitor.fields.folderName.value }}
        </span>
        <div *ngIf='!visitor.fields.folderName.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT and EMAIL -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.departmentName?.visible">
      <div class="info info-department" [ngClass]="{ 'grey': !visitor.fields.departmentName.value }" title="{{ 'bcVisitorInfo.departmentName' | translate }} {{ visitor.fields.departmentName.value }}">
        <svg-icon icon="department-alt"></svg-icon>
        <span class="value visitor-info-department" *ngIf='visitor.fields.departmentName.value'>
          {{ visitor.fields.departmentName.value }}
        </span>
        <div *ngIf='!visitor.fields.departmentName.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- FACEBOOK and ASYNC_MESSAGE -->
    <div class="visitor-info-item" [hidden]="!isFacebook() && !isAsyncMessage()" *ngIf="visitor.fields?.gender?.visible">
      <div class="info info-gender" [ngClass]="{ 'grey': !visitor.fields.gender.value }" title="{{ 'bcVisitorInfo.visitorGender' | translate }} {{ visitor.fields.gender.value }}">
        <svg-icon icon="gender"></svg-icon>
        <span class="value visitor-info-gender" *ngIf='visitor.fields.gender.value'>
            {{ visitor.fields.gender.value }}
        </span>
        <div *ngIf='!visitor.fields.gender.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" [hidden]="!isChat()" *ngIf="visitor.fields?.ip?.visible">
      <div class="info info-ip" [ngClass]="{ 'grey': !visitor.fields.ip.value }" title="{{ 'bcVisitorInfo.ip' | translate }} {{ visitor.fields.ip.value }}">
        <svg-icon icon="ip"></svg-icon>
        <span class="value visitor-info-ip" *ngIf='visitor.fields.ip.value'>
            {{ visitor.fields.ip.value }}
        </span>
        <div *ngIf='!visitor.fields.ip.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" [hidden]="!isChat()" *ngIf="visitor.fields?.website?.visible">
      <div class="info info-website" [ngClass]="{ 'grey': !visitor.fields.website.value }" title="{{ 'bcVisitorInfo.website' | translate }} {{ visitor.fields.website.value }}">
        <svg-icon icon="mobile" *ngIf='visitor.clientType === bcEnums.visitorClientTypes.MOBILE'></svg-icon>
        <svg-icon icon="desktop" *ngIf='visitor.clientType === bcEnums.visitorClientTypes.DESKTOP'></svg-icon>
        <span class="value visitor-info-website" *ngIf="visitor.fields.website.value">
          {{ visitor.fields.website.value }}
        </span>
        <div *ngIf='!visitor.fields.website.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" [hidden]="!isChat()" *ngIf="visitor.fields?.chatLaunchUrl?.visible">
      <div class="info info-chat-launch-url" [ngClass]="{ 'grey': !visitor.fields.chatLaunchUrl.value }" title="{{ 'bcVisitorInfo.chatLaunchUrl' | translate  }} {{ visitor.fields.chatLaunchUrl.value }}">
        <svg-icon icon="chat-launch-url"></svg-icon>
        <span class='value visitor-info-chat-launch-url' *ngIf="visitor.fields.chatLaunchUrl.value">
          {{ visitor.fields.chatLaunchUrl.value }}
        </span>
        <div *ngIf='!visitor.fields.chatLaunchUrl.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" [hidden]="!isChat()" *ngIf="visitor.fields?.cityRegion?.visible">
      <div class="info info-city-region" [ngClass]="{ 'grey': !visitor.fields.cityRegion.value }" title="{{ 'bcVisitorInfo.cityRegion' | translate }} {{ visitor.fields.cityRegion.value }}">
        <svg-icon icon="location"></svg-icon>
        <span class='value visitor-info-city-region' *ngIf='visitor.fields.cityRegion.value'>
          {{ visitor.fields.cityRegion.value }}
        </span>
        <div *ngIf='!visitor.fields.cityRegion.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" [hidden]="!isChat()" *ngIf="visitor.fields?.country?.visible">
      <div class="info info-country" [ngClass]="{ 'grey': !visitor.fields.country.value }" title="{{ 'bcVisitorInfo.country' | translate }} {{ visitor.fields.country.value }}">
        <svg-icon icon="globe"></svg-icon>
        <span class='value visitor-info-country' *ngIf='visitor.fields.country.value'>
          {{ visitor.fields.country.value }}
        </span>
        <div *ngIf='!visitor.fields.country.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" [hidden]="!isChat()" *ngIf="visitor.fields?.currentUrl?.visible">
      <div class="info info-current-url" [ngClass]="{ 'grey': !visitor.fields.currentUrl.value }" title="{{ 'bcVisitorInfo.currentUrl' | translate }} {{ visitor.fields.currentUrl.value }}">
        <svg-icon icon="push"></svg-icon>
        <span class='value visitor-info-current-url' *ngIf='visitor.fields.currentUrl.value'>
          <a [href]="visitor.fields.currentUrl.value" target="_blank">{{ visitor.fields.currentUrl.value }}</a>
        </span>
        <div *ngIf='!visitor.fields.currentUrl.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT and EMAIL -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.customField1?.visible">
      <div class="info info-custom-field1" [ngClass]="{ 'grey': !visitor.fields.customField1.value }" title="{{ 'bcVisitorInfo.customField1' | translate }} {{ visitor.fields.customField1.value }}">
        <svg-icon icon="custom-field-1"></svg-icon>
        <span class="value visitor-info-custom-field1" *ngIf='visitor.fields.customField1.value'>
          {{ visitor.fields.customField1.value }}
        </span>
        <div *ngIf='!visitor.fields.customField1.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT and EMAIL -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.customField2?.visible" >
      <div class="info info-custom-field2" [ngClass]="{ 'grey': !visitor.fields.customField2.value }" title="{{ 'bcVisitorInfo.customField2' | translate }} {{ visitor.fields.customField2.value }}">
        <svg-icon icon="custom-field-2"></svg-icon>
        <span class="value visitor-info-custom-field2" *ngIf='visitor.fields.customField2.value'>
          {{ visitor.fields.customField2.value }}
        </span>
        <div *ngIf='!visitor.fields.customField2.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.visitInfo?.visible" >
      <div class="info info-visit-info" [ngClass]="{ 'grey': !visitor.fields.visitInfo.value }" title="{{ 'bcVisitorInfo.visitInfo' | translate  }} {{ visitor.fields.visitInfo.value }}">
        <svg-icon icon="info"></svg-icon>
        <span class="value visitor-info-visit-info" *ngIf='visitor.fields.visitInfo.value'>
          {{ visitor.fields.visitInfo.value }}
        </span>
        <div *ngIf='!visitor.fields.visitInfo.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" *ngIf="visitor.fields?.visitRef?.visible">
      <div class="info info-visit-ref" [ngClass]="{ 'grey': !visitor.fields.visitRef.value }" title="{{ 'bcVisitorInfo.visitRef' | translate  }} {{ visitor.fields.visitRef.value }}">
        <svg-icon icon="notes"></svg-icon>
        <span class="value visitor-info-visit-ref" *ngIf='visitor.fields.visitRef.value'>
          {{ visitor.fields.visitRef.value }}
        </span>
        <div *ngIf='!visitor.fields.visitRef.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <!-- CHAT ONLY -->
    <div class="visitor-info-item" *ngFor="let customField of visitor.fields?.customPreChatFields">
      <div class="info info-pre-chat-custom" [ngClass]="{ 'grey': !customField.value }" title="{{ customField.label }}: {{ customField.value }}">
        <svg-icon icon="notes"></svg-icon>
        <span class="value visitor-info-pre-chat-custom-field" *ngIf='customField.value'>
            {{ customField.value }}
        </span>
        <div *ngIf='!customField.value' class='not-available'>{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
      </div>
    </div>

    <div class="visitor-info-item" *ngIf="visitor.fields?.phoneNumber?.visible">
      <div class="info info-phone" [ngClass]="{ 'grey': !visitor.fields.phoneNumber.value }" title="{{ 'bcVisitorInfo.phoneNumber' | translate }} {{ visitor.fields.phoneNumber.value }}">
        <svg-icon icon="mobile"></svg-icon>
        <a (click)="editPhone()" *ngIf="canEdit" class="edit-icon"><i class="glyphicon glyphicon-pencil"></i></a>
        <form *ngIf="editingPhone" (ngSubmit)="editPhone()">
          <input class="bc-input"
                 id="phone-input-field"
                 [(ngModel)]="visitor.fields.phoneNumber.value"
                 (ngModelChange)="restrictPhone()"
                 [ngModelOptions]="{standalone: true}"
                 type="tel"
                 maxlength="30"
                 [ngClass]="{ 'invalid': !visitor.fields.phoneNumber.value }"
                 #phoneNumberInput />
        </form>
        <span class="value not-available" *ngIf="!visitor.fields.phoneNumber.value && !editingPhone">{{ 'bcVisitorInfo.notAvailable' | translate }}</span>
        <span class="value visitor-info-phone" *ngIf="visitor.fields.phoneNumber.value && !editingPhone">
          <a href="tel:{{ visitor.fields.phoneNumber.value }}">{{ visitor.fields.phoneNumber.value }}</a>
        </span>
      </div>
    </div>
  </div>
</div>
